import AceEditor from 'vue2-ace-editor';
import 'brace/theme/chrome';
import 'brace/ext/language_tools';
import 'brace/mode/javascript';
import 'brace/snippets/javascript';
import 'brace/mode/html';
import 'brace/mode/css';

export default {
  name: 'CodeEditor',
  data: () => ({
    content: '',
  }),
  props: {
    lang: {
      type: String,
      default: '',
      required: true,
    },
    scriptType: {
      type: String,
      default: '',
    },
    componentName: {
      type: String,
      default: '',
    },
    callback: {
      type: Function,
      required: true,
    },
  },
  components: {
    AceEditor,
  },
  methods: {
    editorInit() {
      let prefilledContent;
      switch (this.lang) {
        case 'javascript':
          if (!this.scriptType) {
            prefilledContent =
            `angular.module('BB').component('${this.componentName}', {\n \n \n});`;
          } else {
            prefilledContent = '';
          }
          break;
        case 'html':
          prefilledContent = '<!DOCTYPE html>\n<html>\n \n \n</html>';
          break;
        case 'css':
          prefilledContent = '';
          break;
        default:
      }

      this.content = prefilledContent;
    },
    getContent() {
      console.log(`${this.lang.toUpperCase()} \n ${this.content}`);
    },
    executeFn() {
      return this.callback(this.content);
    },
  },
};
